module.exports = __webpack_public_path__ + "img/SPDarkMode.522f65e5.png";